import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteArea = async (id: number) => {
	const response = await cmsClient.delete(`/homepage/admin/store/area/${id}/`);

	return response.data;
};

const useDeleteArea = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Area deleted" />, {
			hideProgressBar: true
		});
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-areas"]);
	};

	return useMutation(deleteArea, { onSuccess, onError, onSettled });
};

export default useDeleteArea;
